module.exports = __webpack_public_path__ + "static/media/chapter.5b4cbaeb.svg";